/* Svensk katalog for locale-closing-tax-no.js (del 1 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'clo.close': 'Stäng',
  'clo.change': 'Ändra',
  'clo.save': 'Spara',
  'clo.cancel': 'Avbryt',
  'clo.showDetails': 'Visa detaljer',
  'clo.sum': 'Summa',
  'clo.addAsset': 'Lägg till anläggningstillgång',
  'clo.no': 'Nej',
  'clo.delete': 'Ta bort',
  'clo.details': 'Detaljer',
  'clo.addedByUser': 'Tillagd av användare',
  'clo.removeChange': 'Ta bort ändring',
  'clo.done': 'Klar',
  'clo.required': 'Obligatoriskt',
  'clo.seeDetails': 'se detaljer',
  'clo.searchAccounts': 'Sök bland konton',
  'clo.noMatches': 'Inga träffar',
  'clo.searchShort': 'Sök …',
  'clo.addValue': 'Lägg till värde',
  'clo.pick': 'Välj',
  'clo.changed': 'Ändrad',
  'clo.override': 'Åsidosätt',
  'clo.add': 'Lägg till',
  'clo.type': 'Typ',
  'clo.amount': 'Belopp',
  'clo.wealthValue': 'Förmögenhetsvärde',
  'clo.totalReportableBenefit': 'Sammanlagd uppgiftspliktig ersättning',
  'clo.autoCalculated': 'Beräknas automatiskt',
  'clo.valueType': 'Värdetyp',
  'clo.bookValue': 'Bokföringsmässigt värde',
  'clo.taxValue': 'Skattemässigt värde',
  'clo.inventoryTotal': 'Summa värde av varulager',
  'clo.inventorySpec': 'Specifikation av varulager',
  'clo.equityChange': 'Förändring av eget kapital',
  'clo.equityChangeType': 'Typ av förändring av eget kapital',
  'clo.principleChange': 'Principändring',
  'clo.plBalanceType': 'Typ av resultat- och balansräkning',
  'clo.cannotChange': 'Kan inte ändras',
  'clo.description': 'Beskrivning',
  'clo.openingEquity': 'Ingående eget kapital',
  'clo.equityChanges': 'Förändringar av eget kapital',
  'clo.profitLossForYear': 'Årets överskott/underskott',
  'clo.principleChanges': 'Principändringar',
  'clo.closingEquity': 'Utgående eget kapital',
  'clo.addEquityChange': 'Lägg till förändring av eget kapital',
  'clo.addPrincipleChange': 'Lägg till principändring',
  'clo.principleChangeHelp': 'Välj det bokföringskonto som principändringen gäller. Beloppen sparas bara i utkastet till skattemeldingen.',
  'clo.employerTaxBenefit': 'Sammanlagd arbetsgivaravgiftspliktig ersättning',
  'clo.accountNumber': 'Kontonummer',
  'clo.accountName': 'Kontonamn',
  'clo.reportableSalaryBenefit': 'Uppgiftspliktig lön och förmån',
  'clo.employerTaxBenefitShort': 'Arbetsgivaravgiftspliktig ersättning',
  'clo.detailedPayrollCost': 'Detaljerad löne- och pensionskostnad',
  'clo.detailedPayrollHelp': 'Ange den skattemässiga specifikationen per konto. Uppgifterna sparas bara i utkastet till skattemeldingen.',
  'clo.addDetailedPayroll': 'Lägg till detaljerad löne- och pensionskostnad',
  'clo.noTempDiffsShort': 'Inga temporära skillnader registrerade',
  'clo.changeVerb': 'ändra',
  'clo.lastYear': 'I fjol',
  'clo.thisYear': 'I år',
  'clo.movement': 'Förändring',
  'clo.bookValueHelp': 'Värdet så som det är bokfört enligt regnskapslovens regler — t.ex. baserat på historiskt anskaffningsvärde minus bokföringsmässiga avskrivningar.',
  'clo.taxValueHelp': 'Värdet så som det beräknas enligt skattelagens regler — t.ex. baserat på saldoavskrivning. Avviker ofta från det bokföringsmässiga värdet.',
  'clo.difference': 'Skillnad',
  'clo.differenceHelp': 'Differensen mellan bokföringsmässigt och skattemässigt värde. Skillnaden återförs över tid och påverkar skatteunderlaget. Förändringen i årets skillnad läggs till eller dras av i beräkningen av årets skatteunderlag.',
  'clo.permanentDiff': 'Permanent skillnad',
  'clo.permanentDiffType': 'Typ av permanent skillnad',
  'clo.additionToBusinessIncome': 'Tillägg till näringsinkomst',
  'clo.deductionFromBusinessIncome': 'Avdrag från näringsinkomst',
  'clo.optionalDescription': 'Valfri beskrivning',
  'clo.temporaryDiff': 'Temporär skillnad',
  'clo.temporaryDiffType': 'Typ av temporär skillnad',
  'clo.bookValuePrevYear': 'Bokföringsmässigt värde föregående inkomstår',
  'clo.taxValuePrevYear': 'Skattemässigt värde föregående inkomstår',
  'clo.diffMovement': 'Förändring i skillnad',
  'clo.back': 'Tillbaka',
  'clo.calculation': 'Beräkning',
  'clo.taxBase': 'Skatteunderlag',
  'clo.lossCarryforward': 'Underskott att föra vidare',
  'clo.deferredTaxOrAsset': 'Uppskjuten skatt / skattefordran',
  'clo.permanentDiffs': 'Permanenta skillnader',
  'clo.noPermanentDiffs': 'Inga permanenta skillnader registrerade.',
  'clo.temporaryDiffs': 'Temporära skillnader',
  'clo.noTemporaryDiffs': 'Inga temporära skillnader registrerade.',
  'clo.additionalSpecs': 'Tilläggsspecifikationer',
  'clo.assetsAndInventory': 'Tillgångar och varulager',
  'clo.sharesAndInvestments': 'Aktier och investeringar',
  'clo.otherWealth': 'Annan förmögenhet',
  'clo.debt': 'Skulder',
  'clo.objectIdentifier': 'Objektidentifierare',
  'clo.basis': 'Underlag',
  'clo.closingValue': 'Utgående värde',
  'clo.noAssetsRegistered': 'Inga anläggningstillgångar eller vinst-/förlustkonton registrerade.',
  'clo.otherCompanyInfo': 'Andra bolagsuppgifter',
  'clo.investments': 'Investeringar',
  'clo.noInvestments': 'Inga investeringar registrerade.',
  'clo.incomeStatement': 'Resultaträkning',
  'clo.operatingIncome': 'Rörelseintäkt',
  'clo.operatingCost': 'Rörelsekostnad',
  'clo.balanceSheet': 'Balansräkning',
  'clo.totalAssets': 'Summa tillgångar',
  'clo.totalEquity': 'Summa eget kapital',
  'clo.totalDebt': 'Summa skulder',
  'clo.totalEquityAndDebt': 'Summa eget kapital och skulder',
  'clo.manualAdditions': 'Manuella tillägg i utkastet till skattemeldingen',
  'clo.additionalItems': 'Tilläggsposter',
  'clo.specifications': 'Specifikationer',
  'clo.taxReturnLead': 'Skattemeldingen för bolaget bygger på bokföringen. Plumme skapar ett preliminärt utkast till skatteunderlag, förmögenhet och skulder.',
  'clo.aboutTaxReturn': 'Om skattemeldingen',
  'clo.aboutTaxReturnHelp': 'Plumme bygger skattemeldingen på din bokföring. Du går igenom varje steg, kontrollerar siffrorna och skickar in. Senare hämtas och lämnas siffror direkt mot Skatteetaten och Altinn.',
  'clo.incomeYear': 'Inkomstår',
  'clo.incomeYearHelp': 'Räkenskapsåret som skattemeldingen gäller. Byt år längst upp till höger i appen om du ska arbeta med ett annat år.',
  'clo.financialYear': 'Räkenskapsåret',
  'clo.calculatedTax': 'Beräknad skatt',
  'clo.calculatedTaxHelp': 'Preliminär skatt som Plumme beräknar utifrån skatteunderlaget (överskott justerat för permanenta och temporära skillnader) multiplicerat med skattesatsen. Om resultatet är negativt blir det 0 och underskottet förs vidare.',
  'clo.lossCarryforwardHelp': 'Ett skattemässigt underskott i år kan dras av mot överskott under senare år. Det här beloppet sparas och används automatiskt nästa gång du har överskott.',
  'clo.toNextYear': 'Till nästa år',
  'clo.fetchAndCreateDraft': 'Hämta uppgifter och skapa utkast',
  'clo.fetchAndCreateDraftHelp': 'I dag bygger Plumme utkastet på siffrorna du själv har bokfört. Hämtning av förifyllda siffror direkt från Skatteetaten och Altinn kommer senare — tills vidare skapas utkastet lokalt. Därefter går du igenom varje steg, kontrollerar och skickar in.',
  'clo.checkContactInfo': 'Kontrollera kontaktuppgifter',
  'clo.checkContactInfoHelp': 'Kontaktpersonen som Skatteetaten använder om de har frågor om din skattemelding. Hämtas från Plumme-användaren men kan ändras här.',
  'clo.name': 'Namn',
  'clo.phone': 'Telefonnummer',
  'clo.email': 'E-postadress',
  'clo.mobile': 'Mobilnummer',
  'clo.editContactInfo': 'Ändra kontaktuppgifter',
  'clo.hasAuditor': 'Har företaget en revisor?',
  'clo.hasAuditorHelp': 'Revisionspliktiga bolag måste få skattemeldingen godkänd av en registrerad revisor före inlämning. De flesta små AS är inte revisionspliktiga så länge de håller sig under gränsvärdena för omsättning, balansomslutning och anställda.',
  'clo.auditorConfirms': 'Skattemeldingen ska bekräftas av revisor',
  'clo.filingDetails': 'Uppgifter om inlämningen',
  'clo.taxpayer': 'Skattskyldig',
  'clo.filer': 'Inlämnare',
  'clo.contactInfo': 'Kontaktuppgifter',
  'clo.accountingPeriod': 'Räkenskapsperiod',
  'clo.annualAccountsRuleType': 'Regeltyp för årsredovisning',
  'clo.annualAccountsRuleTypeHelp': 'Vilket regelverk årsredovisningen upprättas enligt. Små företag (under vissa gränsvärden för omsättning, balansomslutning och anställda) kan använda förenklade regler. IFRS är internationella standarder som främst är aktuella för större/börsnoterade bolag.',
  'clo.auditorApproval': 'Ska skattemeldingen godkännas av revisor',
  'clo.taxBaseHelp': 'Beloppet som skatten beräknas på. Utgår från det redovisade resultatet, justerat för permanenta och tillfälliga skillnader och eventuellt balanserat underskott. Kallas även alminnelig inntekt.',
  'clo.taxRate': 'Skattesats',
  'clo.taxRateHelp': 'Procentsatsen som skatten beräknas med. För aktiebolag är den allmänna bolagsskatten 22 % av skatteunderlaget.',
  'clo.taxPayable': 'Skatt att betala',
  'clo.taxPayableHelp': 'Skatten som bolaget faktiskt måste betala för året: skatteunderlag × skattesats. Är underlaget negativt (underskott) blir skatten att betala 0 och underskottet balanseras.',
  'clo.wealthAndDebt': 'Förmögenhet och skulder',
  'clo.wealth': 'Förmögenhet',
  'clo.totalWealthAndDebt': 'Summa förmögenhet och skulder från näringsverksamhet',
  'clo.netWealthHelp': 'Nettoförmögenhet: förmögenhet minus skulder. Utgör underlag för ägarnas förmögenhetsskatt. Ett AS kan inte ha negativ nettoförmögenhet — då rapporteras 0 kr.',
  'clo.checkTempDiffsLastYear': 'Kontrollera tillfälliga skillnader från i fjol',
  'clo.checkTempDiffsHelp': 'Ingående värden (01.01) för tillfälliga skillnader och balanserat underskott ska stämma med fjolårets skattemelding. Avvikelser måste rättas innan du går vidare.',
  'clo.tempDiffsAtOpening': 'Tillfälliga skillnader per 01.01',
  'clo.tempDiffsAtOpeningHelp': 'Summan av tillfälliga skillnader vid årets början — hämtad från fjolårets skattemelding. Ska stämma med utgående värde i fjol.',
  'clo.lossCarryforwardAtOpening': 'Balanserat underskott per 01.01',
  'clo.lossCarryforwardAtOpeningHelp': 'Outnyttjat skattemässigt underskott från tidigare år som förs in i året och kan dras av mot årets överskott.',
  'clo.profitBeforeTax': 'Resultat före skatt',
  'clo.profitBeforeTaxHelp': 'Redovisat överskott eller underskott före skattekostnad — alla intäkter minus alla kostnader som de står i bokföringen.',
  'clo.permanentDiffsExTax': 'Permanenta skillnader exkl. skatt',
  'clo.permanentDiffsExTaxHelp': 'Intäkter som är skattefria eller kostnader utan avdragsrätt. Dessa försvinner aldrig — de påverkar skatten detta år och återförs inte senare (t.ex. ej avdragsgill representation).',
  'clo.tempDiffMovement': 'Förändring i tillfällig skillnad',
  'clo.tempDiffMovementHelp': 'Årets förändring i skillnader mellan redovisning och skatt som utjämnas över tid (t.ex. olika avskrivningar). Förskjuter när skatten betalas, men inte totalt.',
  'clo.priorLossUsedHelp': 'Tidigare års underskott som används för att minska årets skatteunderlag.',
  'clo.taxBaseResultHelp': 'Resultatet av justeringarna ovan — beloppet som skatten faktiskt beräknas på. Kallas även alminnelig inntekt.',
  'clo.corporateRateHelp': 'Allmän bolagsskattesats för aktiebolag.',
  'clo.taxToPayHelp': 'Skatten som ska betalas: skatteunderlag × 22 %. Blir 0 vid underskott.',
  'clo.deferredTaxCalc': 'Beräkning av uppskjuten skatt / uppskjuten skattefordran',
  'clo.deferredTaxBasisHelp': 'Samlade skillnader mellan redovisade och skattemässiga värden som kommer att utjämnas i framtiden.',
  'clo.lossCarryforwardShort': 'Balanserat underskott',
  'clo.lossCarryforwardShortHelp': 'Outnyttjat underskott som kan dras av mot framtida överskott.',
  'clo.unrecognisedDeferredAsset': 'Ej bokförd uppskjuten skattefordran',
  'clo.deferredTaxBasis': 'Underlag för beräkning av uppskjuten skatt',
  'clo.deferredTax': 'Uppskjuten skatt',
  'clo.deferredTaxHelp': 'Skatt som hör till året men betalas först senare (uppskjuten skatt) — eller en framtida skattebesparing (uppskjuten skattefordran). Visas i balansräkningen, inte som skatt att betala nu.',
  'clo.permanentDiffsHelp': 'Intäkter som är skattefria eller kostnader som inte ger avdragsrätt — för all framtid, inte bara tillfälligt. Exempel: utdelning enligt fritaksmetoden, ej avdragsgill representation eller böter. Läggs till (tillägg) eller dras från (avdrag) det redovisade resultatet för att komma fram till skatteunderlaget.',
  'clo.addPermanentDiffItem': 'Lägg till post för permanent skillnad',
  'clo.addPermanentDiffItemHelp': 'Lägg till intäkter som är skattefria eller kostnader utan avdragsrätt som inte redan hämtats in automatiskt. Välj typ och ange beloppet.',
  'clo.addPermanentDiff': 'Lägg till permanent skillnad',
  'clo.temporaryDiffsHelp': 'Skillnader mellan redovisade och skattemässiga värden som utjämnas över tid. T.ex. skiljer sig avskrivningssatserna i regnskapsloven och skatteloven, vilket ger olika kostnad varje år — men totalkostnaden blir densamma. Förändring i tillfällig skillnad påverkar när skatten betalas, inte den totala skattebelastningen.',
  'clo.addTempDiffItem': 'Lägg till post för tillfällig skillnad',
  'clo.addTempDiffItemHelp': 'Tillfälliga skillnader som Plumme inte har hämtat automatiskt kan läggas till manuellt här. Välj post (konto/tillgångstyp) och ange redovisat och skattemässigt värde.',
  'clo.addTempDiff': 'Lägg till tillfällig skillnad',
  'clo.lossCarryforwardLongHelp': 'Skattemässigt underskott från ett år kan föras över till kommande år och användas för att minska skatteunderlaget när bolaget har överskott. Det finns ingen tidsgräns för att föra underskott framåt i Norge — det kan användas så länge det finns överskott att kvitta mot.',
  'clo.priorLossCarried': 'Balanserat underskott från tidigare år',
  'clo.priorLossCarriedHelp': 'Ackumulerat skattemässigt underskott från år före detta år. Beloppet förs automatiskt över från fjolårets skattemelding.',
  'clo.debtSettlement': 'Uppnått frivilligt ackord och skuldeftergift',
  'clo.debtSettlementHelp': 'Om borgenären efterger skuld genom ett frivilligt ackord kan detta minska det balanserade underskottet. Kallades tidigare även underhandsackord. Påverkar inte beräkningen i Plumme – för in det i skattemeldingen hos Skatteetaten.',
  'clo.debtSettlementRest': 'Rest av uppnått frivilligt ackord och skuldeftergift',
  'clo.debtSettlementRestHelp': 'Eventuellt återstående skuldeftergiftsbelopp som ännu inte använts för att minska underskottet.',
  'clo.lossUsedThisYear': 'Årets utnyttjande av balanserat underskott från tidigare år',
  'clo.lossUsedThisYearHelp': 'Hur mycket av det balanserade underskottet som används för att kvitta mot årets överskott. Får inte överstiga årets skatteunderlag (före denna post).',
  'clo.lossCarryforwardInIncome': 'Underskott att föra vidare i inkomst',
  'clo.lossCarryforwardInIncomeHelp': 'Resulterande underskott att föra vidare till nästa år: föregående saldo minus årets utnyttjande, plus eventuellt nytt underskott.',
  'clo.addSpecification': 'Lägg till specifikation',
  'clo.overview': 'Översikt',
  'clo.notCalculatedInPlumme': 'Påverkar inte beräkningen i Plumme – för in det i skattemeldingen hos Skatteetaten.',
  'clo.taxAssetsNotCalculated': 'Tillgångar som du lägger till manuellt här påverkar inte beräkningen i Plumme – för in dem i skattemeldingen hos Skatteetaten. Bara inventarier från tillgångsregistret ingår i skatteunderlaget.',
  'clo.notCalculatedTitle': 'Beräknad skatt måste klargöras.',
  'clo.notCalculatedBody': 'Utkastet innehåller uppgifter som inte ingår i Plummes skatteberäkning: {{items}}. För in dem i skattemeldingen hos Skatteetaten och låt en redovisningskonsult kontrollera skatten.',
  'clo.notCalculatedInput.groupContribution': 'koncernbidrag',
  'clo.notCalculatedInput.skattefunn': 'SkatteFUNN',
  'clo.notCalculatedInput.foreignTaxCredit': 'avdrag för skatt betald utomlands',
  'clo.notCalculatedInput.foreignSubsidiaryTaxCredit': 'avdrag för skatt på utdelning från utländskt dotterbolag',
  'clo.notCalculatedInput.foreignTaxReversal': 'återförd utländsk skatt',
  'clo.notCalculatedInput.debtForgiveness': 'underhandsackord och skuldeftergift',
  'clo.notCalculatedInput.manualTaxAssets': 'manuellt tillagda tillgångar',
  'clo.taxProvisionStaleTitle': 'Bokförd skatt är inaktuell.',
  'clo.taxProvisionStaleBody': 'Skatteunderlaget har ändrats efter att året stängdes. Bokförd skatt att betala är {{booked}}, medan utkastet nu ger {{current}}. Öppna året igen och stäng det på nytt innan skattemeldingen eller årsredovisningen lämnas in.',
  'clo.lossUsedThisYearCalculatedHelp': 'Beräknas automatiskt för aktiebolag: tidigare underskott används mot årets positiva skatteunderlag så långt det räcker, och utnyttjandet kan inte skjutas upp.',
  'clo.aiTaxAssetSaved': 'Tillgången har lagts till i tillgångsspecifikationen i utkastet. Den påverkar inte skatteberäkningen i Plumme – för in den i skattemeldingen hos Skatteetaten.',
  'clo.contactInfoSaved': 'Kontaktuppgifter sparade',
  'clo.taxDraftSaveFailed': 'Kunde inte spara utkastet till skattemelding.',
  'clo.taxBasisSaveFailed': 'Kunde inte spara skatteunderlaget.',
  'clo.itemAdded': '{{title}} tillagd',
  'clo.permanentDiffSaved': 'Permanent skillnad sparad',
  'clo.entryDeleted': 'Posten togs bort',
  'clo.temporaryDiffSaved': 'Tillfällig skillnad sparad',
  'clo.specificationRemoved': 'Specifikation borttagen',
  'clo.taxAssetSaveFailed': 'Kunde inte spara tillgångsspecifikationen.',
  'clo.assetSaved': '{{title}} sparad',
  'clo.assetFallback': 'Tillgång',
  'clo.objectDeleted': 'Objektet togs bort',
  'clo.taxOtherSaveFailed': 'Kunde inte spara övriga uppgifter.',
  'clo.ownerBenefitsSaved': 'Förmåner sparade',
  'clo.companyInfoSaved': 'Bolagsuppgifter sparade',
  'clo.soleTraderChecksSaved': 'ENK-kontrollerna har sparats',
  'clo.taxSettlementSaved': 'Slutskattebeskedet har sparats',
  'clo.investmentSaved': '{{title}} sparad',
  'clo.investmentFallback': 'Investering',
  'clo.investmentDeleted': 'Investeringen togs bort',
  'clo.incomeBalanceSaveFailed': 'Kunde inte spara resultaträkning och balansräkning.',
  'clo.enterAccountBeforeSaving': 'Ange kontonummer och kontonamn innan du sparar posten.',
  'clo.entrySaved': 'Post sparad',
  'clo.entryDeletedShort': 'Post borttagen',
  'clo.specificationSaved': 'Specifikation sparad',
  'clo.specificationDeleted': 'Specifikation borttagen',
  'clo.detailedPayrollSpecDeleted': 'Detaljerad lönespecifikation borttagen',
  'clo.equityChangeSaved': 'Förändring i eget kapital sparad',
  'clo.equityChangeDeleted': 'Förändring i eget kapital borttagen',
  'clo.principleChangeSaved': 'Principändring sparad',
  'clo.principleChangeDeleted': 'Principändring borttagen',
  'clo.draftMissingControls': 'Utkastet saknar {{count}} obligatoriska kontroller. Se varningen högst upp och fyll i fälten innan du går vidare.',
  'clo.dividendPaidInYear': 'Utdelning som beslutades och betalades ut under {{year}}',
  'clo.companyToOwnerBenefit': 'Har bolaget lämnat lån, ställt säkerhet, sålt eller hyrt ut till ägare eller närstående?',
  'clo.ownerToCompanyBenefit': 'Har ägare eller närstående lämnat lån, ställt säkerhet, sålt eller hyrt ut till bolaget?',
  'clo.loansToOwnerAmount': 'Utestående lån eller förmåner från bolaget till ägaren',
  'clo.loansFromOwnerAmount': 'Utestående lån från ägaren till bolaget',
  'clo.securityAmount': 'Ställda säkerheter för ägare eller närstående',
  'clo.noteField': 'Anteckning',
  'clo.industryRegime': 'Bransch och särregler',
  'clo.industryRegimeOrdinary': 'Vanlig verksamhet',
  'clo.industryRegimeAgricultureForestry': 'Jordbruk eller skogsbruk – kräver fackmässig hantering',
  'clo.industryRegimeRegulatedFinance': 'Reglerad finansverksamhet – kräver fackmässig hantering',
  'clo.industryRegimeOtherSpecial': 'Annan särregel – kräver fackmässig hantering',
  'clo.financeTaxApplicability': 'Omfattas bolaget av finansskatt',
  'clo.financeTaxNotApplicable': 'Nej',
  'clo.financeTaxApplicable': 'Ja – kräver fackmässig hantering',
  'clo.financeTaxUnknown': 'Inte klargjort',
  'clo.ownsProperty': 'Ägde bolaget fast egendom vid årets slut',
  'clo.propertyTaxValue': 'Sammanlagt skattemässigt värde av fast egendom',
  'clo.propertyDetails': 'Fastighet – adress, typ och värderingsunderlag',
  'clo.groupReceivablesAmount': 'Fordringar på koncernföretag',
  'clo.groupDebtAmount': 'Skulder till koncernföretag',
  'clo.groupDetails': 'Koncernposter och motparter',
  'clo.businessIncomeReviewed': 'Näringsinkomsten är kontrollerad mot bokföringen',
  'clo.otherPersonalIncomeReviewed': 'Övriga inkomster och avdrag i den personliga skattemeldingen är kontrollerade',
  'clo.personalReturnReviewed': 'Den personliga skattemeldingen ska kontrolleras tillsammans med näringsspesifikasjonen',
  'clo.duplicateIncomeChecked': 'Samma inkomst eller avdrag har inte tagits med både privat och i näringsverksamheten',
  'clo.spouseAllocationStatus': 'Fördelning med make/maka',
  'clo.spouseAllocationNotApplicable': 'Inte aktuellt',
  'clo.spouseAllocationReviewed': 'Fördelningen är bedömd och dokumenterad',
  'clo.spouseAllocationRequiresReview': 'Måste klargöras med redovisningskonsult',
  'clo.spouseShareAmount': 'Belopp fördelat till make/maka',
  'clo.spouseAllocationBasis': 'Underlag för fördelningen',
  'clo.advanceTaxPaid': 'Ordinarie preliminärskatt inbetald',
  'clo.additionalAdvanceTax': 'Extra preliminärskatt inbetald',
  'clo.taxSettlementStatus': 'Status för slutskattebeskedet',
  'clo.taxSettlementPending': 'Inte mottaget',
  'clo.taxSettlementReceived': 'Mottaget – inte färdigbokfört',
  'clo.taxSettlementSettled': 'Kontrollerat och bokfört',
  'clo.finalAssessedTax': 'Fastställd skatt i slutskattebeskedet',
  'clo.interestIncome': 'Ränteintäkt i beskedet',
  'clo.interestExpense': 'Räntekostnad i beskedet',
  'clo.settlementDate': 'Datum för slutskattebeskedet',
  'clo.settlementNotesOrRef': 'Anteckning eller dokumentreferens',
  'clo.noBalanceOnRelevantAccounts': 'Inget saldo på relevanta konton.',
  'clo.submissionAndCompany': 'Inlämning och företag',
  'clo.statusReady': 'Klar',
  'clo.statusMissingInfo': 'Saknar info',
  'clo.statusControl': 'Kontrollera',
  'clo.statusNoItems': 'Inga poster',
  'clo.statusDiscrepancy': 'Avvikelse',
  'clo.objectsCount': '{{count}} objekt',
  'clo.investmentsCount': '{{count}} investeringar',
  'clo.company': 'Företag',
  'clo.orgNumber': 'Organisationsnummer',
  'clo.taxAssetsCard': 'Tillgångar',
  'clo.otherInfoCard': 'Övriga uppgifter',
  'clo.incomeBalanceCard': 'Resultaträkning och balansräkning',
  'clo.balanceDeviation': 'Balansavvikelse',
  'clo.dividend': 'Utdelning',
  'clo.companyToOwnerShort': 'Bolag till ägare',
  'clo.ownerToCompanyShort': 'Ägare till bolag',
  'clo.investmentsShort': 'Investeringar',
  'clo.operatingIncomeShort': 'Rörelseintäkt',
  'clo.annualResultShort': 'Årets resultat',
  'clo.totalAssetsShort': 'Summa tillgångar',
  'clo.added': 'Tillagd',
  'clo.noSharesOrInvestmentsInTrialBalance': 'Inga aktie- eller investeringsposter hittades i råbalansen.',
  'clo.debtRelatedTo': 'Skulder relaterade till',
  'clo.valueColumn': 'Värde',
  'clo.noDebtItemsInTrialBalance': 'Inga skuldposter hittades i råbalansen.',
  'clo.prepareTaxBeforeClosing': 'Förbered skatten innan året stängs',
  'clo.prepareTaxBeforeClosingBody': 'Gå igenom skatteunderlaget nu. Plumme använder det godkända underlaget för att kontera skatt att betala när bokslutet stängs. Själva inlämningen är spärrad tills efter stängningen.',
  'clo.taxReturnTitle': 'Skattemelding {{year}}',
  'clo.taxReturnIntro': 'Skattemeldingen består av uppgifter från bokföringen. Senare hämtar vi siffror direkt från Skatteetaten och Altinn — tills vidare skapar vi ett lokalt utkast med de siffror du redan har bokfört.',
  'clo.netBusinessIncome': 'Netto näringsinkomst',
  'clo.mustBeClarified': 'Måste klargöras',
  'clo.includedInPersonalTaxReturn': 'Ingår i innehavarens personliga skattemelding',
  'clo.mustBePaid': 'Måste betalas',
  'clo.noCalculatedTaxInDraft': 'Ingen beräknad skatt i utkastet',
  'clo.noRateApplied': 'Ingen sats har använts',
  'clo.taxCalcRequiresReview': 'Skatteberäkningen kräver professionell bedömning',
  'clo.taxCalcRequiresReviewBody': 'Bokföringssiffrorna kan gås igenom, men skatt att betala beräknas inte förrän bransch, finansskatt och övrig skatteregim har klargjorts.',
  'clo.taxReturnNotReadyYet': 'Skattemeldingen är inte klar än.',
  'clo.mandatoryChecksMissing': '{{count}} obligatoriska kontroller saknas. Gå särskilt igenom skatteunderlag och övriga uppgifter.',
  'clo.taxReturnInternallyReviewed': 'Utkastet är internt granskat. Det är inte validerat av Skatteetaten.',
  'clo.draftForCompany': 'Utkast för {{company}}. Gå igenom varje steg och bekräfta siffrorna.',
  'clo.theBusinessFallback': 'företaget',
  'clo.reviewDone': 'Klar med genomgången',
  'clo.continueLabel': 'Gå vidare',
  'clo.taxCalculatedForYear': 'Beräknad skatt för räkenskapsåret {{year}}',
  'clo.notCalculated': 'Inte beräknad',
  'clo.noAdditionsRegistered': 'Inga tillägg registrerade',
  'clo.noDeductionsRegistered': 'Inga avdrag registrerade',
  'clo.calculatedFromAccountCannotEdit': 'Beräknas från konto {{code}} och kan inte redigeras här.',
  'clo.calculatedFromAssetRegisterCannotEdit': 'Beräknas från tillgångsregistret och kan inte redigeras här.',
  'clo.missingPriorTaxYear': 'Vi saknar ett tidigare skatteår att kontrollera mot. Öppna beloppet ovan och spara 0 om det inte finns något underskott att föra vidare.',
  'clo.sumWealthAndDebtAtYearEnd': 'Summa förmögenhet och skulder per 31.12.{{year}}',
  'clo.limitedCompanyNoNegativeWealth': 'Ett aktiebolag kan inte ha negativ nettoförmögenhet. Därför rapporteras 0 kr i förmögenhet för det här bolaget även om "Summa förmögenhet och skulder" är negativ.',
  'clo.noFixedAssetsRegisteredForYear': 'Inga anläggningstillgångar eller vinst-/förlustkonton registrerade för {{year}}.',
  'clo.personalTaxReturnAndBusinessIncome': 'Personlig skattemelding och näringsinkomst',
  'clo.personalTaxReturnAndBusinessIncomeBody': 'Ett ENK är inget eget skattesubjekt. Kontrollera näringsinkomsten tillsammans med övriga personliga inkomster, avdrag och förmögenhet, och undvik att samma belopp rapporteras både privat och i näringsverksamheten.',
  'clo.businessIncomeFromDraft': 'Näringsinkomst från utkastet',
  'clo.personalTaxReturnChecked': 'Personlig skattemelding kontrollerad',
  'clo.spouseAllocationDetailStatus': 'Fördelning med make/maka',
  'clo.spouseAllocationReviewedShort': 'Bedömd',
  'clo.duplicateIncomeCheckedLabel': 'Dubbelrapportering kontrollerad',
  'clo.fillInChecks': 'Fyll i kontrollerna',
  'clo.enkPersonalTaxReturnTitle': 'ENK – personlig skattemelding och näringsinkomst',
  'clo.ownerBenefitsBetweenCompanyAndOwnerTitle': 'Förmåner mellan bolaget och personlig ägare',
  'clo.otherCompanyInfoTitle': 'Övriga uppgifter om bolaget',
  'clo.advanceTaxAndSettlementTitle': 'Preliminärskatt och skatteavräkning',
  'clo.note': 'Anteckning',
  'clo.advanceTaxAndSettlement': 'Preliminärskatt och skatteavräkning',
  'clo.advanceTaxAndSettlementBody': 'Registrera inbetald preliminärskatt när skattemeldingen förbereds. När skatteavräkningen kommer kontrolleras fastställd skatt, ränta och eventuell kvarskatt eller skatt att få tillbaka innan den bokförs.',
  'clo.advancePlusAdditionalPaid': 'Inbetald preliminärskatt och extra preliminärskatt',
  'clo.estimatedDifferenceVsCalculatedTax': 'Uppskattad differens mot beräknad skatt',
  'clo.settlementStatusLabel': 'Status',
  'clo.settlementReceivedShort': 'Mottagen',
  'clo.settlementNotReceivedShort': 'Inte mottagen',
  'clo.updateSettlement': 'Uppdatera avräkningen',
  'clo.fillSharesInfoBody': 'Rapportera aktier, fonder, obligationer, virtuell valuta och andra finansiella instrument som bolaget äger. Poster från råbalansen visas automatiskt som förslag.',
  'clo.noSharesOrInvestmentsFound': 'Inga aktier eller investeringar hittades i råbalansen. Lägg till manuella uppgifter om bolaget äger sådana poster.',
  'clo.sumSalesIncome': 'Summa försäljningsintäkter',
  'clo.sumOtherOperatingIncome': 'Summa övriga rörelseintäkter',
  'clo.sumGoodsCost': 'Summa varukostnad',
  'clo.sumPayrollCost': 'Summa lönekostnad',
  'clo.sumDepreciation': 'Summa avskrivningar',
  'clo.sumOtherOperatingCost': 'Summa övriga rörelsekostnader',
  'clo.sumFinanceIncome': 'Summa finansiella intäkter',
  'clo.sumFinanceCost': 'Summa finansiella kostnader',
  'clo.balanceDiscrepancyWithAmount': 'Balansavvikelse: {{amount}}. Kontrollera råbalansen före inlämning.',
  'clo.inventoryValueTitle': 'Värde på varulager',
  'clo.receivableTaxValueTitle': 'Skattemässigt värde på fordringar',
  'clo.payrollPensionSpecTitle': 'Specifikation av löne- och pensionskostnad',
  'clo.incomeKind': 'Intäkt',
  'clo.costKind': 'Kostnad',
  'clo.balanceKind': 'Balans',
  'clo.balanceDiscrepancyBody': 'Tillgångar och eget kapital/skulder avviker med {{amount}}. Rätta avvikelsen i bokföringen innan skattemeldingen kontrolleras för inlämning.',
  'clo.detailsFallback': 'Detaljer',
  'clo.reviewStepsIntro': 'Gå igenom stegen till vänster. När allt är bekräftat kan utkastet kontrolleras för inlämning.',
  'clo.internalRulesOnly': 'Utkastet har bara kontrollerats mot Plummes interna regler. Officiell validering och inlämning hos Skatteetaten är inte ansluten.',
  'clo.processingStepPlaceholder': 'Vi visar detta som ett behandlingssteg tills vidare. När en riktig integration finns hämtas status från Skatteetaten.',
  'clo.netWealthLabel': 'Nettoförmögenhet',
});
